var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "footer__copyright" }, [
      _vm._v(
        "Copyright © " +
          _vm._s(_vm.year) +
          " Fuel Medical Group. All rights reserved."
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }